import { jsx } from 'panel';
import { SvgIconEl } from 'common/components/svg-icon';
import { TagTheme } from './types';
export function template() {
  const isBreadcrumb = this.attr("theme") === TagTheme.Breadcrumb;
  const isRemoveable = !isBreadcrumb && this.attr("removable");
  return jsx("div", {
    sel: '.mp-tag',
    class: {
      clickable: this.attr("clickable"),
      removable: this.attr("removable"),
      [this.attr("theme")]: true,
      [this.attr("size") === this.helpers.TagSize.Small ? "small-tag" : "default-tag"]: true
    },
    on: {
      click: this.attr("clickable") ? this.helpers.select : null
    }
  }, this.attr("icon") ? jsx("div", {
    sel: '.tag-extra-icon'
  }, jsx(SvgIconEl, {
    attrs: {
      icon: this.attr("icon")
    }
  })) : null, jsx("div", {
    sel: '.tag-name'
  }, this.attr("tag-name")), isBreadcrumb && jsx("div", {
    sel: '.tag-caret-icon'
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "caret-right"
    }
  })), isRemoveable && jsx("div", {
    sel: '.tag-remove-icon',
    on: {
      click: this.helpers.remove
    }
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "x"
    }
  })));
}